import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Check, Columns3 } from 'lucide-react'
import { COLUMNS, type ColumnDef } from './columns'
import styles from './deployments.module.css'

interface ColumnToggleProps {
  visible: readonly string[]
  onToggle: (id: string) => void
  onReset: () => void
}

function Group({ title, columns, visible, onToggle }: { title: string; columns: ColumnDef[]; visible: readonly string[]; onToggle: (id: string) => void }) {
  return (
    <>
      <DropdownMenu.Label className={styles.menuLabel}>{title}</DropdownMenu.Label>
      {columns.map((column) => (
        <DropdownMenu.CheckboxItem
          key={column.id}
          className={styles.menuItem}
          checked={visible.includes(column.id)}
          data-testid={`column-toggle-${column.id}`}
          // Keep the menu open so several columns can be toggled in one go.
          onSelect={(event) => event.preventDefault()}
          onCheckedChange={() => onToggle(column.id)}
        >
          <span className={styles.menuCheck}>
            <DropdownMenu.ItemIndicator>
              <Check size={11} />
            </DropdownMenu.ItemIndicator>
          </span>
          {column.label}
        </DropdownMenu.CheckboxItem>
      ))}
    </>
  )
}

/** Column picker. The choice is remembered per viewer (see useColumnPreferences). */
export function ColumnToggle({ visible, onToggle, onReset }: ColumnToggleProps) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button type="button" className={styles.menuButton} data-testid="column-toggle">
          <Columns3 size={14} /> Columns
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content className={styles.menu} align="end" sideOffset={6} collisionPadding={8}>
          <DropdownMenu.Item className={styles.menuItem} data-testid="column-reset" onSelect={onReset}>
            Reset to default
          </DropdownMenu.Item>
          <DropdownMenu.Separator className={styles.menuSeparator} />
          <Group title="Deployment" columns={COLUMNS.filter((c) => c.group === 'existing')} visible={visible} onToggle={onToggle} />
          <DropdownMenu.Separator className={styles.menuSeparator} />
          <Group title="WorkWise" columns={COLUMNS.filter((c) => c.group === 'workwise')} visible={visible} onToggle={onToggle} />
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
